import { useState } from "react";
import CustomInput from "../../../../custom-components/form-inputs/CustomInput";
import PasswordEyeIconSVG from "../../svg/PasswordEyeIconSVG";
import { FormikProps } from "formik";
import { Fields } from "../../../../types/SchemaFactory";

interface PasswordInputProps<T> {
    form: FormikProps<T>;
    name: keyof T;
    fields: Fields<T>;
}

function PasswordInput<T>(props: PasswordInputProps<T>) {
    const [isPasswordVisible, setPasswordVisibility] = useState<boolean>(false);

    return (
        <div className="relative w-full">
            <CustomInput
                form={props.form}
                name={props.name}
                fields={props.fields}
                type={!isPasswordVisible ? "password" : "text"}
                className="w-full h-[63px] dmax2:h-[45px] mb-3 dmax2:mb-2 pr-[76px] dmax2:pr-[52px]"
            />
            <PasswordEyeIconSVG
                className="absolute right-[25px] dmax2:right-[16px] bottom-[30px] dmax2:bottom-[15px] cursor-pointer dmax2:w-[22px] text-textFaded"
                isPasswordVisible={isPasswordVisible}
                setPasswordVisible={setPasswordVisibility}
            />
        </div>
    );
}

export default PasswordInput;
